var _g, _g2, _g3, _g4, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -2.13005,
    y: -2.79899,
    width: 20.2621,
    height: 22.096
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      clipPath: "url(#bgblur_0_17847_292038_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_17847_292038)",
    "data-figma-bg-blur-radius": 4.13103
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1143 14.892C11.0276 15.0654 10.8476 15.1654 10.6676 15.1654C10.5943 15.1654 10.5143 15.1454 10.4476 15.112L8.20578 13.9942C8.0768 13.9298 7.92511 13.9298 7.79613 13.9942L5.55429 15.112C5.48762 15.1454 5.40762 15.1654 5.33429 15.1654C5.15429 15.1654 4.97429 15.0654 4.88762 14.892C4.76095 14.6387 4.86095 14.3387 5.11429 14.2187L7.24722 13.1522C7.40272 13.0745 7.50095 12.9155 7.50095 12.7417V11.791C7.50095 11.5375 7.70646 11.332 7.95996 11.332H8.04195C8.29545 11.332 8.50095 11.5375 8.50095 11.791V12.7417C8.50095 12.9155 8.59918 13.0745 8.75468 13.1522L10.8876 14.2187C11.141 14.3387 11.241 14.6387 11.1143 14.892Z",
    fill: "url(#paint0_linear_17847_292038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1143 14.892C11.0276 15.0654 10.8476 15.1654 10.6676 15.1654C10.5943 15.1654 10.5143 15.1454 10.4476 15.112L8.20578 13.9942C8.0768 13.9298 7.92511 13.9298 7.79613 13.9942L5.55429 15.112C5.48762 15.1454 5.40762 15.1654 5.33429 15.1654C5.15429 15.1654 4.97429 15.0654 4.88762 14.892C4.76095 14.6387 4.86095 14.3387 5.11429 14.2187L7.24722 13.1522C7.40272 13.0745 7.50095 12.9155 7.50095 12.7417V11.791C7.50095 11.5375 7.70646 11.332 7.95996 11.332H8.04195C8.29545 11.332 8.50095 11.5375 8.50095 11.791V12.7417C8.50095 12.9155 8.59918 13.0745 8.75468 13.1522L10.8876 14.2187C11.141 14.3387 11.241 14.6387 11.1143 14.892Z",
    fill: "url(#paint1_linear_17847_292038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.68519 1.33203C2.75502 1.33203 2.00098 2.08608 2.00098 3.01624V9.3987C2.00098 10.6654 2.66764 11.332 3.93431 11.332H12.0676C13.3343 11.332 14.001 10.6654 14.001 9.3987V3.01624C14.001 2.08608 13.2469 1.33203 12.3168 1.33203H3.68519ZM11.321 5.7187L9.22098 7.47203C9.02764 7.63203 8.78098 7.6987 8.54764 7.6587C8.30764 7.6187 8.10098 7.47203 7.97431 7.2587C7.60642 6.64555 6.77828 6.50511 6.22881 6.96269L5.32098 7.7187C5.22764 7.7987 5.11431 7.83203 5.00098 7.83203C4.86098 7.83203 4.71431 7.77203 4.61431 7.65203C4.43431 7.4387 4.46764 7.12536 4.68098 6.94536L6.78098 5.19203C6.97431 5.03203 7.22098 4.96536 7.45431 5.00536C7.69431 5.04536 7.90098 5.19203 8.02764 5.40536C8.39553 6.01851 9.22367 6.15896 9.77314 5.70138L10.681 4.94536C10.8943 4.76536 11.2076 4.7987 11.3876 5.01203C11.561 5.22536 11.5343 5.5387 11.321 5.7187Z",
    fill: "url(#paint2_linear_17847_292038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.68519 1.33203C2.75502 1.33203 2.00098 2.08608 2.00098 3.01624V9.3987C2.00098 10.6654 2.66764 11.332 3.93431 11.332H12.0676C13.3343 11.332 14.001 10.6654 14.001 9.3987V3.01624C14.001 2.08608 13.2469 1.33203 12.3168 1.33203H3.68519ZM11.321 5.7187L9.22098 7.47203C9.02764 7.63203 8.78098 7.6987 8.54764 7.6587C8.30764 7.6187 8.10098 7.47203 7.97431 7.2587C7.60642 6.64555 6.77828 6.50511 6.22881 6.96269L5.32098 7.7187C5.22764 7.7987 5.11431 7.83203 5.00098 7.83203C4.86098 7.83203 4.71431 7.77203 4.61431 7.65203C4.43431 7.4387 4.46764 7.12536 4.68098 6.94536L6.78098 5.19203C6.97431 5.03203 7.22098 4.96536 7.45431 5.00536C7.69431 5.04536 7.90098 5.19203 8.02764 5.40536C8.39553 6.01851 9.22367 6.15896 9.77314 5.70138L10.681 4.94536C10.8943 4.76536 11.2076 4.7987 11.3876 5.01203C11.561 5.22536 11.5343 5.5387 11.321 5.7187Z",
    fill: "url(#paint3_linear_17847_292038)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 7.70705,
    y: 6.53713,
    width: 8.91988,
    height: 9.42574
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      clipPath: "url(#bgblur_1_17847_292038_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_17847_292038)",
    "data-figma-bg-blur-radius": 3.99998
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.707 11.9623H12.0321C12.3571 11.9623 12.6271 11.6722 12.6271 11.3222C12.6271 10.8872 12.4721 10.8021 12.2171 10.7121L11.712 10.5371V11.9623H11.707Z",
    fill: "url(#paint4_linear_17847_292038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1797 10.8164V10.8174C12.308 10.8627 12.3828 10.8979 12.4316 10.958C12.4787 11.016 12.5156 11.1156 12.5156 11.3223C12.5156 11.6186 12.2884 11.8515 12.0322 11.8516H11.8232V10.6934L12.1797 10.8164Z",
    stroke: "url(#paint5_linear_17847_292038)",
    strokeWidth: 0.222221
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 6.04104,
    y: 4.04104,
    width: 8.915,
    height: 9.42965
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      clipPath: "url(#bgblur_2_17847_292038_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_17847_292038)",
    "data-figma-bg-blur-radius": 3.99998
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.041 8.68609C10.041 9.12115 10.196 9.20616 10.4511 9.29617L10.9561 9.47119V8.04102H10.6311C10.306 8.04102 10.041 8.33105 10.041 8.68609Z",
    fill: "url(#paint6_linear_17847_292038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6309 8.15234H10.8447V9.31445L10.4883 9.19141C10.36 9.14612 10.2852 9.11082 10.2363 9.05078C10.1892 8.99283 10.1524 8.8931 10.1523 8.68652C10.1523 8.38337 10.3764 8.15248 10.6309 8.15234Z",
    stroke: "url(#paint7_linear_17847_292038)",
    strokeWidth: 0.222221
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 4.19366,
    y: 4.45636,
    width: 15.0844,
    height: 15.0834
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      clipPath: "url(#bgblur_3_17847_292038_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_17847_292038)",
    "data-figma-bg-blur-radius": 3.54169
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7363 11.9985C15.7363 14.2079 13.9452 15.999 11.7358 15.999C9.52643 15.999 7.73535 14.2079 7.73535 11.9985C7.73535 9.78913 9.52643 7.99805 11.7358 7.99805C13.9452 7.99805 15.7363 9.78913 15.7363 11.9985Z",
    fill: "url(#paint8_linear_17847_292038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7354 8.1748C13.8468 8.1748 15.5593 9.88666 15.5596 11.998C15.5596 14.1097 13.847 15.8223 11.7354 15.8223C9.62397 15.822 7.91211 14.1095 7.91211 11.998C7.91237 9.88683 9.62413 8.17507 11.7354 8.1748Z",
    stroke: "url(#paint9_linear_17847_292038)",
    strokeWidth: 0.354171
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_17847_292038",
    x: -2.13005,
    y: -2.79899,
    width: 20.2621,
    height: 22.096,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.573754,
    dy: 0.573754
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.286877
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_17847_292038"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_17847_292038_clip_path",
    transform: "translate(2.13005 2.79899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1143 14.892C11.0276 15.0654 10.8476 15.1654 10.6676 15.1654C10.5943 15.1654 10.5143 15.1454 10.4476 15.112L8.20578 13.9942C8.0768 13.9298 7.92511 13.9298 7.79613 13.9942L5.55429 15.112C5.48762 15.1454 5.40762 15.1654 5.33429 15.1654C5.15429 15.1654 4.97429 15.0654 4.88762 14.892C4.76095 14.6387 4.86095 14.3387 5.11429 14.2187L7.24722 13.1522C7.40272 13.0745 7.50095 12.9155 7.50095 12.7417V11.791C7.50095 11.5375 7.70646 11.332 7.95996 11.332H8.04195C8.29545 11.332 8.50095 11.5375 8.50095 11.791V12.7417C8.50095 12.9155 8.59918 13.0745 8.75468 13.1522L10.8876 14.2187C11.141 14.3387 11.241 14.6387 11.1143 14.892Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.68519 1.33203C2.75502 1.33203 2.00098 2.08608 2.00098 3.01624V9.3987C2.00098 10.6654 2.66764 11.332 3.93431 11.332H12.0676C13.3343 11.332 14.001 10.6654 14.001 9.3987V3.01624C14.001 2.08608 13.2469 1.33203 12.3168 1.33203H3.68519ZM11.321 5.7187L9.22098 7.47203C9.02764 7.63203 8.78098 7.6987 8.54764 7.6587C8.30764 7.6187 8.10098 7.47203 7.97431 7.2587C7.60642 6.64555 6.77828 6.50511 6.22881 6.96269L5.32098 7.7187C5.22764 7.7987 5.11431 7.83203 5.00098 7.83203C4.86098 7.83203 4.71431 7.77203 4.61431 7.65203C4.43431 7.4387 4.46764 7.12536 4.68098 6.94536L6.78098 5.19203C6.97431 5.03203 7.22098 4.96536 7.45431 5.00536C7.69431 5.04536 7.90098 5.19203 8.02764 5.40536C8.39553 6.01851 9.22367 6.15896 9.77314 5.70138L10.681 4.94536C10.8943 4.76536 11.2076 4.7987 11.3876 5.01203C11.561 5.22536 11.5343 5.5387 11.321 5.7187Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_17847_292038",
    x: 7.70705,
    y: 6.53713,
    width: 8.91988,
    height: 9.42574,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.555553,
    dy: 0.555553
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.277776
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_17847_292038"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_17847_292038_clip_path",
    transform: "translate(-7.70705 -6.53713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.707 11.9623H12.0321C12.3571 11.9623 12.6271 11.6722 12.6271 11.3222C12.6271 10.8872 12.4721 10.8021 12.2171 10.7121L11.712 10.5371V11.9623H11.707Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_17847_292038",
    x: 6.04104,
    y: 4.04104,
    width: 8.915,
    height: 9.42965,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.555553,
    dy: 0.555553
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.277776
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_17847_292038"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_17847_292038_clip_path",
    transform: "translate(-6.04104 -4.04104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.041 8.68609C10.041 9.12115 10.196 9.20616 10.4511 9.29617L10.9561 9.47119V8.04102H10.6311C10.306 8.04102 10.041 8.33105 10.041 8.68609Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_17847_292038",
    x: 4.19366,
    y: 4.45636,
    width: 15.0844,
    height: 15.0834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.491901,
    dy: 0.491901
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.245951
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_17847_292038"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_17847_292038_clip_path",
    transform: "translate(-4.19366 -4.45636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7363 11.9985C15.7363 14.2079 13.9452 15.999 11.7358 15.999C9.52643 15.999 7.73535 14.2079 7.73535 11.9985C7.73535 9.78913 9.52643 7.99805 11.7358 7.99805C13.9452 7.99805 15.7363 9.78913 15.7363 11.9985Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17847_292038",
    x1: 8.37135,
    y1: 1.33203,
    x2: -3.20816,
    y2: 13.3398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDFF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17847_292038",
    x1: 8.37135,
    y1: 1.33203,
    x2: 12.1618,
    y2: 16.6224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0063F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17847_292038",
    x1: 8.37135,
    y1: 1.33203,
    x2: -3.20816,
    y2: 13.3398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDFF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17847_292038",
    x1: 8.37135,
    y1: 1.33203,
    x2: 12.1618,
    y2: 16.6224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0063F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0051C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_17847_292038",
    x1: 12.1671,
    y1: 10.5371,
    x2: 11.0316,
    y2: 11.3625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDFF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_17847_292038",
    x1: 13.2877,
    y1: 12.5061,
    x2: 12.0358,
    y2: 12.3241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_17847_292038",
    x1: 10.4986,
    y1: 8.04102,
    x2: 9.36226,
    y2: 8.85964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDFF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_17847_292038",
    x1: 11.6131,
    y1: 10.0169,
    x2: 10.3675,
    y2: 9.83746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_17847_292038",
    x1: 11.7358,
    y1: 7.3313,
    x2: 5.08088,
    y2: 14.8242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDFF6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2B329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_17847_292038",
    x1: 21.4806,
    y1: 18.3853,
    x2: 10.9006,
    y2: 16.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEF4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoard);
export default __webpack_public_path__ + "static/media/board.a6691578da0dd493024b77e57d6ee6d1.svg";
export { ForwardRef as ReactComponent };